<template lang="pug">
div
  b-row(v-show="isSubmitting")
    b-col
      b-card(class="py-5")
        loading(
          :active="true"
          :is-full-page="false"
          color="#498ceb"
        )
  ARRForm(
    v-show="!isSubmitting",
    :data="arrData",
    :on-save-draft="saveDraft",
    @submit="create"
  )
</template>

<script>
import ARRForm from '../shared/ARRForm.vue'
import useResidualRiskAdd from './useResidualRiskAdd'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

export default {
  name: 'ResidualRiskAdd',
  components: {
    ARRForm,
    Loading,
  },
  setup() {
    const { create, saveDraft, arrData, isSubmitting } = useResidualRiskAdd()

    return {
      create,
      saveDraft,
      arrData,
      isSubmitting,
    }
  },
}
</script>
